<script lang="ts" setup>
import { BaseballSubParticipantStatId } from '@collector/sportsapi-client-legacy'
import { useBatterOptions } from '@desktop/views/Relation/Sports/Baseball/composables'

import CurrentPitcherOrBatterSelect from './CurrentPitcherOrBatterSelect.vue'

// composables
const { batterOptions, currentBatter } = useBatterOptions()
</script>

<template>
  <CurrentPitcherOrBatterSelect
    label="Batter"
    :value="currentBatter"
    :options="batterOptions"
    :statId="BaseballSubParticipantStatId.CurrentBatter"
  />
</template>
